import { ref } from "vue";

const isLoading = ref(true);
export const useGlobalLoader = () => {
  const showGlobalLoader = () => {
    isLoading.value = true;
  };

  const hideGlobalLoader = () => {
    isLoading.value = false;
  };

  return {
    showGlobalLoader,
    hideGlobalLoader,
    isLoading,
  };
};
